import {
  FlexBox,
  Pagination,
  PaginationButton,
  PaginationStep,
} from '@vp/swan';
import { useTranslations } from '@vp/om-translations';
import { PREVIOUS, NEXT } from '../../constants/pagination';
import { PaginationSteps } from './PaginationSteps';
import { usePaginationContext } from '../contexts/PaginationContext';

export const PaginationWithEllipses = () => {
  const [orderHistoryPagination = {}] = useTranslations([
    'orderHistoryPagination',
  ]);

  const { currentPageIndex, totalPageCount, onSelectPage } =
    usePaginationContext();

  const isFirstPage = currentPageIndex === 0;
  const isLastPage = currentPageIndex + 1 === totalPageCount;

  const handlePreviousChange = () => {
    if (!isFirstPage) {
      onSelectPage(currentPageIndex - 1);
    }
  };

  const handleNextChange = () => {
    if (!isLastPage) {
      onSelectPage(currentPageIndex + 1);
    }
  };

  const createPaginationStep = (pageNumber: number) => (
    <PaginationStep
      key={`pagination ${pageNumber}`}
      data-testid={`paginationWithEllipses page ${pageNumber}`}
      accessibleText={`${orderHistoryPagination.paginationLabel} ${pageNumber}`}
      onClick={() => onSelectPage(pageNumber - 1)}
      active={pageNumber === currentPageIndex + 1}
    >
      {pageNumber}
    </PaginationStep>
  );

  const firstPage = createPaginationStep(1);
  const lastPage = createPaginationStep(totalPageCount);

  return (
    <FlexBox justifyContent="center" my={10}>
      <Pagination
        accessibleText={orderHistoryPagination.paginationLabel}
        data-testid="paginationWithEllipses"
      >
        <PaginationButton
          href="#"
          data-testid="paginationButton previous"
          variant={PREVIOUS}
          accessibleText={orderHistoryPagination.previousPageAccessibilityLabel}
          disabled={isFirstPage}
          onClick={handlePreviousChange}
          as="button"
        />
        {firstPage}
        <PaginationSteps
          createPaginationStep={createPaginationStep}
          currentPage={currentPageIndex + 1}
        />
        {totalPageCount > 1 ? lastPage : null}
        <PaginationButton
          href="#"
          data-testid="paginationButton next"
          variant={NEXT}
          accessibleText={orderHistoryPagination.nextPageAccessibilityLabel}
          disabled={isLastPage}
          onClick={handleNextChange}
          as="button"
        />
      </Pagination>
    </FlexBox>
  );
};
